"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TYPE;
(function (TYPE) {
    TYPE["HTML"] = "html";
    TYPE["CANVAS"] = "canvas";
})(TYPE = exports.TYPE || (exports.TYPE = {}));
var MODE;
(function (MODE) {
    MODE["PULL"] = "pull";
    MODE["PUSH"] = "push";
})(MODE = exports.MODE || (exports.MODE = {}));
var PUSH;
(function (PUSH) {
    PUSH["TOP"] = "top";
    PUSH["TOPLEFT"] = "topleft";
    PUSH["TOPRIGHT"] = "topright";
    PUSH["LEFT"] = "left";
    PUSH["CENTER"] = "center";
    PUSH["RIGHT"] = "right";
    PUSH["BOTTOM"] = "bottom";
    PUSH["BOTTOMLEFT"] = "bottomleft";
    PUSH["BOTTOMRIGHT"] = "bottomright";
})(PUSH = exports.PUSH || (exports.PUSH = {}));
var FOLLOW;
(function (FOLLOW) {
    FOLLOW["MOUSE"] = "mouse";
    FOLLOW["CURSOR"] = "cursor";
})(FOLLOW = exports.FOLLOW || (exports.FOLLOW = {}));
